import { apiClient } from "./apiClient";

export interface Tamanho {
  id: number;
  nome: string;
  lojaId: number;
  createdAt: string;
  updatedAt: string;
}

export interface TamanhoFilters {
  nome?: string;
  lojaId?: number;
}

export interface TamanhoFormData {
  nome: string;
  lojaId: number;
}

export const tamanhoService = {
  getTamanhos: async (filters?: TamanhoFilters): Promise<Tamanho[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    return apiClient.get(`/tamanhos${queryString ? `?${queryString}` : ""}`);
  },

  createTamanho: async (data: TamanhoFormData): Promise<Tamanho> => {
    return apiClient.post("/tamanhos", data);
  },

  updateTamanho: async (
    id: number,
    data: TamanhoFormData
  ): Promise<Tamanho> => {
    return apiClient.put(`/tamanhos/${id}`, data);
  },

  deleteTamanho: async (id: number): Promise<void> => {
    return apiClient.delete(`/tamanhos/${id}`);
  },
};
